import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { StatusDescriptor } from '../status.model';

/**
 * The one way to render a status as a pill.
 *
 * Data-only: callers pass a `StatusDescriptor` from `deriveDeviceStatus()` /
 * `deriveLinkedDeviceStatus()`; the badge never re-derives from a raw record.
 * Colour comes from the `--app-status-*` tokens via `data-status`, and the icon
 * is always rendered so the state is readable without colour.
 */
@Component({
    selector: 'app-status-badge',
    standalone: true,
    template: `
        @if (showIcon()) {
            <i class="app-status-badge__icon" [class]="status().icon" aria-hidden="true"></i>
        }
        <span class="app-status-badge__label">{{ status().label }}</span>
    `,
    styleUrl: './status-badge.component.scss',
    host: {
        class: 'app-status-badge',
        role: 'status',
        '[attr.data-status]': 'status().key',
        '[attr.data-size]': 'size()',
        '[attr.aria-label]': 'status().label',
        '[title]': 'status().label'
    },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusBadgeComponent {
    status = input.required<StatusDescriptor>();
    size = input<'sm' | 'md'>('md');
    showIcon = input(true);
}
